// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "smbc-e3d1e.firebaseapp.com",
  "projectId": "smbc-e3d1e",
  "storageBucket": "smbc-e3d1e.appspot.com",
  "messagingSenderId": "867894770344",
  "appId": "1:867894770344:web:bfe1dbe807312eaee2209d",
  "measurementId": "G-VFFE7393CS",
  "apiKey": "AIzaSyBXeXdta5Io_3X0g1snVErD5DnjP7Y2TpI"
};
